import { stringToNumber } from './stringToNumber'

/** Converte quantidade do formulário (vírgula) ou número para envio à API (máx. 2 decimais). */
export const quantityToNumber = (value: unknown): number => {
  const num = Number(stringToNumber(value as string))
  if (Number.isNaN(num)) return 0
  return Math.round(num * 100) / 100
}
